export {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ACCOUNT_DATA_RETENTION,
  STORE_KEY_ACCOUNT_OPTIONS,
  STORE_KEY_AUTH,
  STORE_KEY_ID_LIST,
  STORE_KEY_LANG,
  STORE_KEY_LIST,
  STORE_KEY_LISTS_COUNT,
  STORE_KEY_LOGIN_TYPE,
  STORE_KEY_SECURE_OPENER,
  STORE_KEY_USER,
  STORE_KEY_USER_LANG,
  STORE_KEY_USER_LISTS,
  STORE_KEY_USER_OPTIONS
} from 'mailup-react-helpers'
export * from './beeEditor'
export * from './emailPlaceholders'

export const ID_LIST_STORE_KEY = 'id_list'
export const ACCOUNT_STORE_KEY = 'account'
export const DOMAIN_APP_REDIRECTOR = 'messages_app_redirector.aspx?r='

export const LOGIN_TYPE_WEBLOGIN = 0
export const LOGIN_TYPE_ADM = 1
export const LOGIN_TYPE_ADMLIMITED = 2
export const LOGIN_TYPE_RESELLER = 3

export const MAX_TAGS_PER_ROW = 6

export const DATE_PICKER_FORMAT = 'yyyy-MM-dd'

export const MESSAGE_AUTOSAVE_TIMEOUT = 30

export const MESSAGE_LIST_TYPE_ALL = 'all'
export const MESSAGE_LIST_TYPE_NOT_ARCHIVED = 'not-archived'
export const MESSAGE_LIST_TYPE_ARCHIVED = 'archived'
export const MESSAGE_LIST_TYPE_PUBLISHED = 'published'
export const MESSAGE_LIST_TYPE_NOTIFICATION = 'notification'

export const SERVICE_TYPE_CONSOLE = 0
export const SERVICE_TYPE_SMTPPLUS = 1
export const SERVICE_TYPE_FASTEMAIL = 2
export const SERVICE_TYPE_ONETOMANY = 3
export const SERVICE_TYPE_WSIMPORTCONFIRMATI = 4

export const MESSAGE_TYPE_GENERIC = 0
export const MESSAGE_TYPE_WELCOME = 1
export const MESSAGE_TYPE_CONFIRMATION = 2
export const MESSAGE_TYPE_CONTENTSCAMPAIGN = 3

export const MESSAGE_STR_TYPE_GENERIC = 'Generic'
export const MESSAGE_STR_TYPE_WELCOME = 'Welcome'
export const MESSAGE_STR_TYPE_CONFIRMATION = 'Confirmation'
export const MESSAGE_STR_TYPE_CONTENTSCAMPAIGN = 'ContentsCampaign'

export const ENTITY_TYPE_TRIGGER = 'Trigger'
export const ENTITY_TYPE_DYNAMIC_CONTENT = 'DynamicContent'
export const ENTITY_TYPE_ANAGRAPHIC_FILTER = 'Anagraphic_Filter'
export const ENTITY_TYPE_ACTIVITY_FILTER = 'Activity_Filter'
export const ENTITY_TYPE_NONE = 'None'
export const ENTITY_TYPE_AUTOMATION_WORKFLOW = 'AutomationWorkflow'
export const ENTITY_TYPE_ABTEST = 'ABTest'
export const ENTITY_TYPE_WELCOME = 'Welcome'
export const ENTITY_TYPE_CONFIRMATION = 'Confirmation'
export const ENTITY_TYPE_AGGREGATE_REPORT = 'AggregateReport'
export const ENTITY_TYPE_SUBCRIPTION_FORM = 'SubscriptionForm'
export const ENTITY_TYPE_LANDING_PAGE = 'LandingPage'
export const ENTITY_TYPE_POPUP_FORM = 'SubscriptionFormPopUp'

export const COLLABORATION_PROJECT_TYPE_NEWSLETTER = 0
export const COLLABORATION_PROJECT_TYPE_LANDING_PAGE = 1
export const COLLABORATION_PROJECT_TYPE_SUBSCRIPTION_FORM = 2

export const COLLABORATION_PROJECT_STATUS_OPEN = 0
export const COLLABORATION_PROJECT_STATUS_APPROVED = 1
export const COLLABORATION_PROJECT_STATUS_ARCHIVED = 2
export const COLLABORATION_PROJECT_STATUS_DELETED = 3

export const SENDING_SOURCE = {
  Undefined: 0,
  Immediate: 1,
  ScheduledNow: 2,
  Scheduled: 3,
  Trigger: 4,
  ABTestTest: 5,
  ABTestWinner: 6
}

export const SENDING_SOURCE_UNDEFINED = 0
export const SENDING_SOURCE_IMMEDIATE = 1
export const SENDING_SOURCE_SCHEDULED_NOW = 2
export const SENDING_SOURCE_SCHEDULED = 3
export const SENDING_SOURCE_TRIGGER = 4
export const SENDING_SOURCE_ABTEST_TEST = 5
export const SENDING_SOURCE_ABTEST_WINNER = 6
export const SENDING_SOURCE_CAMPAIGN = 7

export const SENDING_STATUS_RUNNING = 'Running'
export const SENDING_STATUS_RETRY_SENDING = 'RetrySending'
export const SENDING_STATUS_ABORTED = 'Aborted'
export const SENDING_STATUS_FAILED = 'Failed'
export const SENDING_STATUS_READY = 'Ready'
export const SENDING_STATUS_SCHEDULED = 'Scheduled'
export const SENDING_STATUS_QUEUECOMPLETED = 'QueueCompleted'
export const SENDING_STATUS_QUEUERUNNING = 'QueueRunning'
export const SENDING_STATUS_QUEUETOEXECUTED = 'QueueToExecuted'
export const SENDING_STATUS_QUEUEFAILED = 'QueueFailed'
export const SENDING_STATUS_QUEUECANCELLED = 'QueueCancelled'
export const SENDING_STATUS_STOPPING = 'Stopping'
export const SENDING_STATUS_ENDING = 'Ending'
export const SENDING_STATUS_NOT_DISTURB = 'NotDisturbTime'

export const PECPLUS_STATUS_IN_PROGRESS = 1
export const PECPLUS_STATUS_COMPLETE = 2
export const PECPLUS_STATUS_ERROR = 3

export const PECPLUS_STATUS_IN_PROGRESS_DESCR = 'Inprogress'
export const PECPLUS_STATUS_COMPLETE_DESCR = 'Complete'
export const PECPLUS_STATUS_ERROR_DESCR = 'Error'

export const SEND_METHOD_TYPE_BANDWIDTH = 0
export const SEND_METHOD_TYPE_FREQUENCY = 1

export const SENDING_ABORT_REASON_NONE = 0
export const SENDING_ABORT_REASON_GRACEPERIOD = 1
export const SENDING_ABORT_REASON_NOSEND = 2
export const SENDING_ABORT_REASON_CONTENTVETTING = 3
export const SENDING_ABORT_REASON_UNKNOWN = 4
export const SENDING_ABORT_REASON_INVALIDPEC = 5

export const SENDING_ABTEST_STATUS_ERROR = -1
export const SENDING_ABTEST_STATUS_UNDEFINED = 0
export const SENDING_ABTEST_STATUS_QUEUE_RUNNING = 1
export const SENDING_ABTEST_STATUS_QUEUE_COMPLETED = 2
export const SENDING_ABTEST_STATUS_WAITING_TESTS = 3
export const SENDING_ABTEST_STATUS_TESTS_COMPLETED = 4
export const SENDING_ABTEST_STATUS_WINNER_READY_TO_SEND = 5
export const SENDING_ABTEST_STATUS_WINNER_MESSAGE_STARTED = 6

export const WORKFLOW_STR_STATUS_ALL = 'All'
export const WORKFLOW_STR_STATUS_DRAFT = 'Draft'
export const WORKFLOW_STR_STATUS_ENABLED = 'Enabled'
export const WORKFLOW_STR_STATUS_DISABLED = 'Disabled'

export const WORKFLOW_STR_TYPE_EVENT = 'Event'
export const WORKFLOW_STR_TYPE_SUBSCRIPTION_DATE = 'SubscriptionDate'
export const WORKFLOW_STR_TYPE_SUBSCRIBER_FIELD = 'SubscriberField'
export const WORKFLOW_STR_TYPE_GROUP = 'Group'
export const WORKFLOW_STR_TYPE_ACTIVITY = 'Activity'
export const WORKFLOW_STR_TYPE_WELCOME_EMAIL = 'WelcomeEmail'
export const WORKFLOW_STR_TYPE_ONBOARDING = 'Onboarding'
export const WORKFLOW_STR_TYPE_BIRTHDAY = 'Birthday'
export const WORKFLOW_STR_TYPE_EVENT_REMINDER = 'EventReminder'
export const WORKFLOW_STR_TYPE_ABANDONED_CHART = 'AbandonedChart'
export const WORKFLOW_STR_TYPE_WELCOME_SERIES = 'WelcomeSeries'

export const PREVIEW_MESSAGE_MODE_EMBED = 'embed'
export const PREVIEW_MESSAGE_MODE_POPUP = 'popup'

export const MESSAGE_MAX_ATTACHMENTS = 5
export const MESSAGE_MAX_ATTACHMENTS_SIZE_KB = 7000
export const MESSAGE_ATTACHMENT_ALLOWED_EXT = [
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.pdf',
  '.txt',
  '.ppt',
  '.pptx',
  '.pps',
  '.ods',
  '.csv',
  '.xml',
  '.zip',
  '.odt',
  '.gif',
  '.jpg',
  '.jpeg',
  '.rar',
  '.rtf',
  '.gif',
  '.xbm',
  '.xpm',
  '.png',
  '.ief',
  '.jpg',
  '.jpe',
  '.jpeg',
  '.tiff',
  '.tif',
  '.rgb',
  '.g3f',
  '.xwd',
  '.pict',
  '.ppm',
  '.pgm',
  '.pbm',
  '.pnm',
  '.bmp',
  '.ras',
  '.pcd',
  '.cgm',
  '.mil',
  '.cal',
  '.fif',
  '.dsf',
  '.cmx',
  '.wi',
  '.dwg',
  '.dxf',
  '.svf',
  '.ics'
]

export const EMOJI_CATEGORIES = [
  'search',
  'recent',
  'smileys',
  'people',
  'nature',
  'foods',
  'activity',
  'places',
  'objects',
  'symbols'
]

export const EmailMessageCheckUpIssueType = {
  BlackListUrlError: 1,
  CheckLiquidCodeError: 2,
  AttachmentsError: 3,
  DynamicContentsError: 4,
  EmptyMessageError: 5,
  LinkCheckWarning: 6,
  LinkTrackingWarning: 7,
  UnsubscribeLinkWarning: 8,
  DynamicFieldsWarning: 9,
  WorkflowWarning: 10,
  BlackListUrlWarning: 11,
  PreheaderInfo: 12,
  MaxSizeInfo: 13,
  WebAnalyticsTrackingInfo: 14,
  BlackListContentError: 15,
  DomainCustomizable: 16
}

export const ABTEST_LIST_STATUS_ALL = null
export const ABTEST_LIST_STATUS_DRAFT = [0, 3, 6]
export const ABTEST_LIST_STATUS_LOADING_TEST = [3, 4]
export const ABTEST_LIST_STATUS_SCHEDULED = [7]
export const ABTEST_LIST_STATUS_TEST_RUNNING = [1]
export const ABTEST_LIST_STATUS_TEST_ENDED = [11, 12]
export const ABTEST_LIST_STATUS_WINNER_SCHEDULED = [13]
export const ABTEST_LIST_STATUS_WINNER_RUNNING = [2]
export const ABTEST_LIST_STATUS_TEST_ABORTED = [15]
export const ABTEST_LIST_STATUS_WINNER_MAILING_ABORTED = [16]
export const ABTEST_LIST_STATUS_FINISHED = [14]

export const ABTEST_LIST_TYPE_ALL = ''
export const ABTEST_LIST_TYPE_AUTO = 'A'
export const ABTEST_LIST_TYPE_MANUAL = 'M'
export const ABTEST_LIST_TYPE_100 = 'X'
export const DEFAULT_PAGE_SIZE = 10

export const ABTEST_SENDING_TYPE_WINNING = 2

export const ABTEST_LIST_CRITERIA_CLICK_RATE = 1
export const ABTEST_LIST_CRITERIA_OPEN_RATE = 2

export const FILTER_TYPE_ANAGRAPHIC = 'Anagraphic'
export const FILTER_TYPE_ACTIVITY = 'Activity'
export const FILTER_TYPE_DEVICE = 'Device'
export const FILTER_TYPE_GEOLOCATION = 'Geolocation'
export const FILTER_TYPE_MULTIFILTER = 'MultiFilter'
export const FILTER_TYPE_MULTITYPE = 'MultiType'
export const FILTER_TYPE_ENGAGEMENT = 'Engagement'

export const MATCH_FILTER_CONDITION_ALL = 'All'
export const MATCH_FILTER_CONDITION_AT_LEAST_ONE = 'AtLeastOne'

export const SENDING_WIZARD_QUEUE_STATUS_RUNNING = 'Running'
export const SENDING_WIZARD_QUEUE_STATUS_TO_EXECUTE = 'ToExecute'
export const SENDING_WIZARD_QUEUE_STATUS_UPDATING = 'Updating'
export const SENDING_WIZARD_QUEUE_STATUS_COMPLETED = 'Completed'
export const SENDING_WIZARD_QUEUE_STATUS_FAILED = 'Failed'
export const SENDING_WIZARD_QUEUE_STATUS_DISCARDED = 'Discarded'
export const SENDING_WIZARD_QUEUE_STATUS_CANCELLES = 'Cancelled'

export const EMIAL_REGEX = /^(([^<>()[]\.,;:\s@"]+(.[^<>()[]\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/i

export const urlRegex = /^(?:(?:\s+)?(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?(?:\s+)?$/

export const INPUT_MESSAGES_MAX_ITEMS = 100
export const INPUT_GROUPS_MAX_ITEMS = 700
export const INPUT_MAX_ITEMS = 100

export const MAX_SAVED_ROW_NUMBER = 30

export const CUSTOM_DOMAIN_CUSTOMIZABLE = 1
export const CUSTOM_DOMAIN_NOT_CUSTOMIZABLE = 2
export const CUSTOM_DOMAIN_CUSTOMIZABLE_WITH_PAYMENT = 3

export const TEMPLATE_TYPE_LOCAL = 'local'
export const TEMPLATE_TYPE_BASIC = 'basic'
export const TEMPLATE_TYPE_RICH = 'rich'
export const GOOGLE_FAQ_URL = 'https://developers.google.com/fonts/faq'
export const GOOGLE_PRIVACY_URL = 'https://www.google.com/policies/privacy'

export const MODE_SCHEDULED = 'MODE_SCHEDULED'
export const MODE_IMMEDIATE = 'MODE_IMMEDIATE'
export const MODE_SMART = 'MODE_SMART'
export const BEE_OPEN_AI_TOTAL_TOKENS = 10000

export const STORE_KEY_BANNER_MAILUP_SHIELD_CLOSED = 'bannerMailupShield'

export const OFFER_TYPE_LIGHT = 8

export const APP_CLIENT_ID = '532d9e1c-b7b2-493f-94db-335c3766bf40'
